import type { DependencyList } from 'react';
import { useEffect, useRef } from 'react';
import { usePaginationParams } from './use-pagination-params';

export const usePageReset = (deps: DependencyList) => {
  const isMountingRef = useRef(false);
  const { handlePageChange } = usePaginationParams();

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return handlePageChange(1);
    } else {
      isMountingRef.current = false;
    }
  }, deps);
};
